export const aboutCeo = {
  uz: {
    aboutCeoTitle:
      "Klinika asoschisi va direktori <br/> <span>Shaymatov Choriqul Ibodullayevich</span>",
    aboutCeoText:
      "<b>Bizning klinika</b> — yuqori malakali mutaxassislardan tarkib topgan va turli ko’z kasalliklari mavjud bo‘lgan bemorlarga sifatli davolash xizmatini ko‘rsatadigan katta oiladir.",
  },
  ru: {
    aboutCeoTitle:
      "Основатель и директор клиники <br /> <span>Шайматов Чоркиул Ибодуллаевич</span>",
    aboutCeoText:
      "<b>Наша клиника</b> — это большая семья, где работают высококвалифицированные специалисты и оказывают качественную медицинскую помощь по восстановлению зрения пациентам с различными офтальмологическими патологиями",
  },
  tj: {
    aboutCeoTitle:
      "Муассис ва директори клиника <br /> <span>Шайматов Чоркиул Ибодуллаевич</span>",
    aboutCeoText:
      "<b>Клиникаи мо</b> - як оилаи калон аст, ки дар он зиеда аз 40 корманд кор мекунанд ва ба беморони гирифтори бемориҳои гуногуни чашм ерии тиббии баландихтисосро барои барқарор кардани биниш пешниҳод мекунанд.",
  },
};
